<template>
  <div class="main common-form-content">
    <el-form
        :model="formData"
        ref="formData"
        size="normal"
        :show-message="false"
        :rules="rules">
      <div class="form-content">
        <el-form-item label="IC卡" prop="cardNo">
          <el-select
              v-model="formData.cardNo"
              placeholder="请选择卡号"
              class="cardSelect"
              style="width: 100%"
              @focus="showPicker = true"
          >
          </el-select>
        </el-form-item>
        <el-form-item label="转账金额" prop="amount" style="border-bottom: 1px solid #ECECEC !important;">
          <el-input
              v-model="formData.amount"
              type="number"
              placeholder="请输入金额"
              maxlength="16"
          ></el-input>
        </el-form-item>
        <div class="max_price">账户余额：{{ handleControlNumber(maxPrice, 2) }}</div>
      </div>
    </el-form>
    <div class="form-sub-box">
      <div class="submit-btn" @click="onSubmit" :class="{'is-submit-state': mixin_submitBtnState}">
        保存
      </div>
    </div>
    <nut-picker
        :is-visible="showPicker"
        :list-data="options"
        @close="close()"
        @confirm="confirm"
    ></nut-picker>
  </div>
</template>
<script>
import {getCardListByCustomerId, transferAccounts} from "@/api/newApi";
import {Toast} from "vant";
import {digitUtil} from "@/utils/utils";
import {validate} from "@/mixins/mixin";

export default {
  name: "transferAccounts",
  mixins: [validate],
  data() {
    let validateNum = (rule, value, callback) => {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (value === "") {
        callback(new Error("请输入金额"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入非负数字"));
        }
        if (value > Number(this.maxPrice)) {
          callback(new Error("可转账金额不得超过" + this.maxPrice));
        }
        callback();
      }
    };
    let validateNo = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请选择卡号"));
      }
      callback();
    };
    return {
      formData: {
        cardNo: "",
        amount: ""
      },
      maxPrice: 0,
      rules: {
        amount: [
          {required: true, message: "请输入金额", trigger: "blur"},
          {validator: validateNum, trigger: "blur"},
        ],
        cardNo: [{validator: validateNo, required: true, trigger: "change"}],
      },
      options: [],
      userId: null,
      showPicker: false
    }
  },
  created() {
    this.userId = this.$route.query.userId
    this.maxPrice = this.$route.query.maxPrice
    this.options = JSON.parse(localStorage.getItem("CARD_LIST"))
  },
  methods: {
    handleControlNumber: digitUtil,
    onSubmit() {
      this.$refs.formData.validate((valid, validObject) => {
        if (valid) {
          let form = {
            ...this.form,
            customerId: this.userId,
          };
          transferAccounts(form).then((res) => {
            if (res.message.code == 0) {
              Toast("转账成功");
              setTimeout(() => {
                this.$router.back(-1)
              }, 1500)
            } else {
              Toast(res.message.message);
            }
          });
        } else {
          let toastMeg = Object.keys(validObject).map(key => {
            return validObject[key][0].message
          })
          Toast(toastMeg[0]);
        }
      });
    },
    close() {
      this.showPicker = false
    },
    confirm(e) {
      this.formData.cardNo = e[0].value;
      this.$forceUpdate();
      this.close()
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/state.scss";

.main {
  min-height: 100%;
  background-color: #FFFFFF;

  .form-content {
    .max_price {
      text-align: right;
      padding: 0.2rem;
      font-size: $fontSize_12;
      color: #a5a4a4;
    }

    ::v-deep .el-form-item {
      .el-form-item__label {
        width: 2.1rem;
        text-align: left;
      }
    }
  }
}
</style>